var map = {
	"./bloqhouse-alt.svg": 5408,
	"./bloqhouse.png": 27745,
	"./bloqhouse.svg": 54140,
	"./idin.svg": 92648,
	"./mollie-logo.svg": 3464,
	"./mollie-secured.svg": 42016,
	"./wave-alt.svg": 51090,
	"./wave.svg": 76269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53709;